/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Legajox_Ingest_Approval_DescriptionInputs */

const es_components_legajox_ingest_approval_description = /** @type {(inputs: Components_Legajox_Ingest_Approval_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El asistente quiere ingestar archivos de Legajox`)
};

const en_components_legajox_ingest_approval_description = /** @type {(inputs: Components_Legajox_Ingest_Approval_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The assistant wants to ingest files from Legajox`)
};

/**
* | output |
* | --- |
* | "The assistant wants to ingest files from Legajox" |
*
* @param {Components_Legajox_Ingest_Approval_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_legajox_ingest_approval_description = /** @type {((inputs?: Components_Legajox_Ingest_Approval_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Legajox_Ingest_Approval_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_legajox_ingest_approval_description(inputs)
	return en_components_legajox_ingest_approval_description(inputs)
});
export { components_legajox_ingest_approval_description as "components.legajox_ingest_approval.description" }